import db from "../db/database";
import { sendToBusinessCentral } from "../utils/businessCentralUtils";
import { getPendingSync, isOnline } from "./syncService";

// Función para verificar si un turno tiene No asignado
const getTurnoNo = async (turnoId) => {
	try {
		// Primero buscamos el turno por su nombre
		const turno = await db.turnos
			.filter((t) => (Number(t.No) === Number(turnoId) || Number(t.id) === Number(turnoId)) && !t.deleted)
			.first();

		if (!turno) {
			console.warn(`Turno "${turnoId}" no encontrado.`);
			return null;
		}

		// Si el turno ya está sincronizado (pendingSync = 0) y tiene No, lo utilizamos
		if (turno.pendingSync === 0 && turno.No !== undefined && turno.No !== null) {
			return turno.No;
		}

		// Si el turno aún no está sincronizado o no tiene No, retornamos null
		return null;
	} catch (error) {
		console.error(`Error al buscar No para turno "${turnoId}":`, error);
		return null;
	}
};

// Función para transformar una apertura de caja al formato esperado por Business Central
const transformAperturaForBC = async (apertura) => {
	// Obtener el No del turno (si existe)
	let turnoNo = await getTurnoNo(apertura.Turno);


	console.log({ turnoNo: turnoNo, Turno: apertura.Turno })

	// Solo incluimos la apertura si el turno tiene No asignado
	if (turnoNo === undefined || turnoNo === null) {
		console.log(
			`Apertura de caja con ID ${apertura.id} no enviada: el turno "${apertura.Turno}" aún no tiene No asignado.`
		);
		return null;
	}

	// Transformar la apertura al formato esperado por BC
	const transformedApertura = {
		No: apertura.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
		No_: apertura.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
		"No.": apertura.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
		Cajero: apertura.Cajero,
		FechaDeApertura: apertura.FechaDeApertura,
		HoraDeApertura: apertura.HoraDeApertura || "00:00", // Añadimos la hora de apertura
		ImporteDeApertura: apertura.ImporteDeApertura,
		Estado: apertura.Estado,
		Turno: turnoNo, // Usamos el No del turno, no su nombre
		Caja: apertura.Caja || "", // Añadimos el No de la caja
		Deleted: apertura.deleted,
	};

	// Crear el formato final esperado por el endpoint
	return {
		data: JSON.stringify({ Aperturas: [transformedApertura] }),
	};
};

export const syncAperturasDeCaja = async () => {
	if (!isOnline()) {
		return false;
	}

	try {
		const pendingAperturasDeCaja = await getPendingSync("aperturaDeCaja");

		// Enviar aperturas de caja pendientes una por una
		if (pendingAperturasDeCaja.length > 0) {
			console.log(
				`Sincronizando ${pendingAperturasDeCaja.length} aperturas de caja pendientes...`
			);

			for (const apertura of pendingAperturasDeCaja) {
				try {
					// Si la apertura está marcada como eliminada, la eliminamos directamente
					if (apertura.deleted) {
						await db.aperturaDeCaja.delete(apertura.id);
						continue;
					}

					// Transformar la apertura para Business Central (verifica si el turno tiene No)
					const transformedData = await transformAperturaForBC(apertura);

					// Si no se pudo transformar (el turno no tiene No), continuamos con la siguiente
					if (!transformedData) {
						continue;
					}

					// Enviar apertura individual a Business Central
					const response = await sendToBusinessCentral(
						"Importaciones_insertaAperturaCaja",
						transformedData,
						true
					);

					// Verificar respuesta y actualizar la apertura con el No asignado por BC
					if (response && response.value) {
						const aperturaNo = response.value;

						console.log(
							`Apertura de caja (ID: ${apertura.id}) sincronizada con No: ${aperturaNo}`
						);

						// Actualizar la apertura local con el No de BC
						await db.aperturaDeCaja.update(apertura.id, {
							No: aperturaNo,
							lastModified: new Date(),
							lastSynced: new Date(),
							pendingSync: 0,
						});
					} else {
						console.error(
							`Error al sincronizar apertura de caja ${apertura.id}: Respuesta inválida de BC`
						);
					}
				} catch (error) {
					console.error(
						`Error al sincronizar apertura de caja ${apertura.id}:`,
						error
					);
				}
			}
		}

		return true;
	} catch (error) {
		console.error("Error al sincronizar aperturas de caja:", error);
		return false;
	}
};
